































































import { Ref, Prop, Vue, Component,  } from "vue-property-decorator";

// Model Class
import { UIModel } from "./../../UIModel";
import cookie from 'js-cookie';
import { FrontendBIM360Hub } from '@/model/frontend/FrontendBIM360Hub';
import { FrontendBIM360Project } from '@/model/frontend/FrontendBIM360Project';

@Component({
    components: {},
    filters: {
        capitalize: function(value: string) {
            if (!value) return ''
            value = value.toString()
            return value.toUpperCase();
        }
    }
})

export default class App extends Vue {
    // Props
    @Prop({ required: true }) public model!: UIModel;

    // Data
    public isActive = false;

    // public ERegion = ERegion;
    get isConectio() {
        return window.location.hostname.toLowerCase().includes("conectio");
    }

    // Getters
    get getHubName(): string {
        if (this.model.selectedHub) {
            return `Hub: ${this.model.selectedHub.name}`;
        } else {
            return "Choose a Hub";
        }
    }

    get getProjectName(): string {
        if (this.model.selectedProject) {
            return `Project: ${this.model.selectedProject.name}`;
        } else {
            return "Choose a Project";
        }
    }

    get hubs_available(): FrontendBIM360Hub[] {
        return this.model.hubs.data;
    }

    get projects_available(): FrontendBIM360Project[] {
        return this.model.projects.data;
    }

    // public regionSwitch(): void {
    //     let exp = new Date();
    //     exp.setSeconds(exp.getSeconds() + 1209600); // 14 days
    //     cookie.set('region', this.model.region);
    // }

    // Methods
    public closeNavbar(): void {
        console.log("Closing navbar");
        this.isActive = false;
    }

    public isProjectSelected(project: FrontendBIM360Project): Boolean {
        return this.model.selectedProject ? project.id == this.model.selectedProject.id : false;            
    }

    public async chooseHub(hub: FrontendBIM360Hub): Promise<void> {
        await this.model.selectHub(hub);
        // if (this.model.selectedProject !== null && this.$route.path != "/issues") {
        //     this.$router.push("/issues");
        // }
    }

    public async chooseProject(project: FrontendBIM360Project): Promise<void> {
        this.model.selectProject(project);
        // if (this.$route.path != "/issues") {
        //     this.$router.push("/issues");
        // }
    }
    public get username() {
        if(this.model.user && this.model.user.name) return this.model.user.name;
        return '';
    }

}
